/**
 * The charset shared by app ids, chat kind names, and model slot names.
 * `AppModelOverrideKeySchema` (shared/ai-features) composes both halves of the
 * `appId:slot` override key from this source, so widening it in one place
 * widens the write path too. Its own file (like ai-tier.ts): both
 * app-registry (features/) and ai-features (shared/) read it, and shared must
 * not import from features.
 */ export const APP_SLUG_PATTERN = '[a-z0-9-]+';

//# sourceMappingURL=app-slug.js.map